export const VSP_OPEN_EVENT = 'ents:vsp:open';

export interface VspOpenEventDetail {
  syan: number;
  colorId?: string;
}

export interface VspPayload {
  syan: number;
  farbId?: string;
  listName: string;
}

export interface VspDispatchParams {
  syan: number;
  colorId?: string;
  listName: string;
}

export function dispatchVspOpen(params: VspDispatchParams): VspPayload {
  const { syan, colorId, listName } = params;
  const payload: VspPayload = {
    syan,
    ...(colorId ? { farbId: colorId } : {}),
    listName,
  };
  const detail: VspOpenEventDetail = { syan, ...(colorId ? { colorId } : {}) };
  document.dispatchEvent(new CustomEvent<VspOpenEventDetail>(VSP_OPEN_EVENT, { detail }));
  return payload;
}
